const { toggleScroll } = require("@/utilities/toggleScroll");

const formOpeners = document.querySelectorAll('.open-popout-form');
const popoutForm = document.querySelector('.popout-form');

formOpeners.forEach((opener) => {
    opener.addEventListener('click', () => {
        popoutForm?.classList.add('open');
        toggleScroll(false);
    });
}
);

const formCloser = document.querySelector('.close-popout-form');
formCloser?.addEventListener('click', () => {
    popoutForm?.classList.remove('open');
    toggleScroll(true);
}
);

